export default "__VITE_ASSET__BDuKTrMv__"